import { useMemo } from 'react';
import { API_BASE_URL } from '../api/client';

export const useImageUrl = (imageId) => {
  return useMemo(() => {
    if (!imageId) return null;
    
    const assetsBaseUrl = API_BASE_URL;
    const baseUrl = assetsBaseUrl || 'http://localhost:8055';
    const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    
    return `${cleanBaseUrl}/assets/${imageId}`;
  }, [imageId]);
};

